import React from 'react'
import './Hero.css'

function Hero() {
  return (
    <div className='hero'>
      <div className='hero__top'>
        <h1>Hello!</h1>
        <img
          src='https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/271/waving-hand_1f44b.png'
          alt=''
        />
      </div>
      <h1>
        I'm <span>Ali Mehdi,</span> a design-minded full stack developer focused
        on building beautiful interfaces & experiences 👨‍💻
      </h1>
      <div className='hero__bottom'>
        <h3>
          Get in touch <span>👉</span>
        </h3>
        <a href='mailto:ali151214.am@outlook.com'>ali151214.am@outlook.com</a>
        <div className='hero__link--bg'></div>
      </div>
    </div>
  )
}

export default Hero
